// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import FileTwoToneSvg from "@ant-design/icons-svg/es/asn/FileTwoTone";
import AntdIcon from '../components/AntdIcon';

var FileTwoTone = function FileTwoTone(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: FileTwoToneSvg
  }));
};

FileTwoTone.displayName = 'FileTwoTone';
export default React.forwardRef(FileTwoTone);


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@ant-design_icons@4.0.6@@ant-design/icons/es/icons/FileTwoTone.js
// module id = 1149
// module chunks = 0